import { Upload, UploadProps } from "antd";
import { RcFile } from "antd/es/upload";
import { File } from "lucide-react";
import { FC } from "react";

type Props = {
  value?: RcFile[];
  onChange?: (value: RcFile[]) => void;
};

export const Attachments: FC<Props> = ({ value, onChange }) => {
  const props: UploadProps = {
    name: "file",
    multiple: true,
    accept: ".pdf,.jpg,.jpeg,.png,.doc",
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
    beforeUpload: (_, fileList) => {
      const isValidFile = fileList.every((file) => {
        const isValidType = [".pdf", ".jpg", ".jpeg", ".png", ".doc"].some(
          (ext) => file.name.endsWith(ext)
        );
        const isValidSize = file.size / 1024 / 1024 < 10; // 10MB
        return isValidType && isValidSize;
      });

      if (isValidFile) {
        onChange?.(fileList);
      }
      return false; // Prevent automatic upload
    },
    listType: "picture",
    fileList: value?.map((file) => ({
      uid: file.name,
      name: file.name,
      status: "done",
      url: URL.createObjectURL(file),
    })),
  };
  return (
    <Upload.Dragger {...props} className="w-full p-6 text-center">
      <div className="p-6 text-center">
        <File size={24} className="mx-auto mb-2 text-gray-400" />
        <p className="text-sm text-gray-500">
          Drag and drop files here, or click to select files
        </p>
        <p className="text-xs text-gray-500 mt-1">
          PDF, JPEG, PNG, DOC (max 10MB per file)
        </p>
        <button
          type="button"
          className="mt-4 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
        >
          Select Files
        </button>
      </div>
    </Upload.Dragger>
  );
};
